module.exports = __webpack_public_path__ + "static/media/WorkoutSignupF.0d068100.png";